import Marionette from 'backbone.marionette';
import navbarTmpl from '../templates/navbar.tpl';
export default Marionette.LayoutView.extend({
  template: navbarTmpl,
  regions: {
    navlinkRegion: "#navlink-region"
  }
  /*events: {
    "click .navbar-toggle": "tog"
  },
  //the wrap is messing with the bootstrap menu - maybe because of it's custom bootstrap? Do it manually here
  tog: function(e){
    $("#top-nav").collapse("toggle");
  }*/
});